import React, {ReactNode} from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {getTextFromReactNode} from '/util/accessibility.util';

import {StaticFocusable} from '../../sections/StaticFocusable';

import {styles} from './SectionTitle.style';
import type {SectionTitleProps} from './SectionTitle.types';

const getSafeText = (title: ReactNode): string => {
  try {
    const raw = getTextFromReactNode(title);
    return typeof raw === 'string' ? raw.trim() : '';
  } catch {
    return '';
  }
};

export const SectionTitle = ({
  title,
  style: styleProp,
  accessibilityRole = 'header',
  required,
}: SectionTitleProps) => {
  const safeText = getSafeText(title);

  const accessibilityLabel =
    required && safeText ? `${safeText}, required` : safeText || undefined;

  return (
    <View style={[styles.section, styleProp]} accessible={false}>
      <StaticFocusable
        testID={`section-heading-${safeText}`}
        label={accessibilityLabel || ''}
        role={accessibilityRole === 'header' ? 'header' : 'text'}>
        <Text
          variant="heading"
          style={styles.title}
          allowFontScaling
          maxFontSizeMultiplier={2}
          accessible={false}
          testID={`section-heading-text-${safeText}`}
          isBold>
          {title}
          {required && <Text style={styles.required}> *</Text>}
        </Text>
      </StaticFocusable>
    </View>
  );
};

export default SectionTitle;
